module.exports = __webpack_public_path__ + "img/world-map.a2df5d4d.png";